import { PromptDataModel } from '../model/general.model';

export const CANCEL_PROMPT_DATA: PromptDataModel = {
  header: "PROMPT.CANCEL_HEADER",
  content: "PROMPT.CANCEL_CONTENT",
  confirmBtn: "PROMPT.CANCEL_OK",
  cancelBtn: "PROMPT.CANCEL_CANCEL"
}

export const CLOSE_ORDER_PROMPT_DATA: PromptDataModel = {
  header: "PROMPT.CLOSE_ORDER_HEADER",
  content: "PROMPT.CLOSE_ORDER_CONTENT",
  confirmBtn: "PROMPT.CLOSE_ORDER_OK",
  cancelBtn: "PROMPT.CLOSE_ORDER_CANCEL"
}

export const COPY_TASK_PROMPT_DATA: PromptDataModel = {
  header: "PROMPT.COPY_TASK_HEADER",
  content: "PROMPT.COPY_TASK_CONTENT",
  confirmBtn: "PROMPT.YES",
  cancelBtn: "PROMPT.CANCEL"
}

export const COPY_TASK_RESPONSE_PROMPT_DATA: PromptDataModel = {
  header: "PROMPT.COPY_FAILURES",
  content: '',
  confirmBtn: "PROMPT.CANCEL_CANCEL",
  hideCancelBtn: true
}

export const SESSION_EXPIRATION_PROMPT_DATA: PromptDataModel = {
  header: "PROMPT.SESSION_HEADER",
  content: "PROMPT.SESSION_CONTENT",
  confirmBtn: "PROMPT.SESSION_OK",
  cancelBtn: "PROMPT.SESSION_CANCEL"
}

export const FAILURE_OPTION_CHANGE_DATA: PromptDataModel = {
  header: "PROMPT.FAILURE_OPTION_CHANGE.HEADER",
  content: "PROMPT.FAILURE_OPTION_CHANGE.CONTENT",
  confirmBtn: "PROMPT.FAILURE_OPTION_CHANGE.OK",
  cancelBtn: "PROMPT.FAILURE_OPTION_CHANGE.CANCEL"
}

export const IRREMOVABLE_FAILURE_DATA: PromptDataModel = {
  header: "PROMPT.IRREMOVABLE_FAILURE_DATA.HEADER",
  content: "PROMPT.IRREMOVABLE_FAILURE_DATA.CONTENT",
  confirmBtn: "PROMPT.IRREMOVABLE_FAILURE_DATA.OK",
  cancelBtn: ""
}

export const GO_ONLINE_PROMPT_DATA: PromptDataModel = {
  header: "PROMPT.GO_ONLINE_HEADER",
  content: "PROMPT.GO_ONLINE_CONTENT",
  confirmBtn: "PROMPT.GO_ONLINE_OK",
  cancelBtn: "PROMPT.GO_ONLINE_CANCEL"
}

export const TASKS_MULTI_APPROVE_PROMPT_DATA: PromptDataModel = {
  header: "PROMPT.MULTI_APPROVE_HEADER",
  content: "PROMPT.MULTI_APPROVE_CONTENT",
  confirmBtn: "YES",
  cancelBtn: "CANCEL"
}
